import { motion, Variants } from 'framer-motion'
import styled from 'styled-components'

interface StageCurtainsProps {
  color?: string
  show: boolean
}
export const StageCurtains: React.FC<StageCurtainsProps> = ({ color, show }) => {
  const variants: Variants = {
    hidden: {
      y: '-100%',
      transition: {
        duration: 0.6,
        ease: [0.65, 0, 0.35, 1],
      },
    },
    visible: {
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.65, 0, 0.35, 1],
      },
    },
  }

  return (
    <Curtains color={color} variants={variants} initial={false} animate={show ? 'visible' : 'hidden'}>
      <h1>[loading...]</h1>
    </Curtains>
  )
}

type CurtainsProps = { color?: string }
const Curtains = styled(motion.div)<CurtainsProps>`
  background-color: ${({ color }) => (color || 'white')};
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    position: absolute;
    z-index: 100;
    /* Why ? */
    transform: translate3d(0px, 0px, 1px);
  }
`
